import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Outline_Color = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🎨 CSS Outline Color</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>outline-color</code> property sets the color of an element’s
        outline. It works together with <code>outline-style</code> and{" "}
        <code>outline-width</code> to create a visible outline around elements.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">Syntax</h2>
        <CodeCopyBlock
          code={`selector {
  outline-color: color | invert;
}`}
        />
        <ul className="tutorial-list">
          <li>
            <code>color</code> → any valid CSS color value (name, HEX, RGB,
            HSL).
          </li>
          <li>
            <code>invert</code> → inverts the outline color to ensure it’s
            visible (less commonly used).
          </li>
        </ul>
      </div>

      {/* Examples */}
      <div className="tutorial-section">
        <h2 className="section-title">Examples</h2>
        <CodeCopyBlock
          code={`p.red {
  outline: solid 3px red;
}

p.hex {
  outline: solid 3px #00bcd4;
}

p.rgb {
  outline: solid 3px rgb(34, 197, 94);
}

p.hsl {
  outline: solid 3px hsl(280, 70%, 50%);
}`}
        />

        {/* Live Demo */}
        <p
          style={{
            border: "2px solid #333",
            outline: "3px solid red",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Red outline (color name)
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "3px solid #00bcd4",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          HEX outline (#00bcd4)
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "3px solid rgb(34, 197, 94)",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          RGB outline (rgb(34, 197, 94))
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "3px solid hsl(280, 70%, 50%)",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          HSL outline (hsl(280, 70%, 50%))
        </p>
      </div>

      {/* Description */}
      <div className="tutorial-section">
        <h2 className="section-title">Important Notes</h2>
        <ul className="tutorial-list">
          <li>An outline must have a style to be visible.</li>
          <li>
            Outline color supports all CSS color formats: names, HEX, RGB, HSL.
          </li>
          <li>
            Unlike <code>border-color</code>, outlines do not support per-side
            colors—they apply to the entire outline.
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After learning <strong>outline-color</strong>, explore{" "}
          <a href="/css/outline-style" className="learn-more">
            Outline Style
          </a>{" "}
          to see different visual styles like dotted, dashed, or double.
        </p>
      </div>
    </div>
  );
};

export default Outline_Color;
